import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import MenuIcon from "@mui/icons-material/Menu"
import { Box, Tab, useTheme } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"
import ApiLoading from "components/ApiLoading"
import CrisisButton from "components/navigation/CrisisButton"
import LanguageButton from "components/navigation/LanguageButton"
import { allRoutes } from "generated/routes"
import React, { useEffect, useState } from "react"
import { Link, NavLink, useLocation } from "react-router-dom"
import { LoginLogout } from "../../../auth/LoginLogoutButton"
import { AppContext } from "../../AppContextProvider"
import CompanySelect from "../CompanySelect"
import {
  StyledAppBar,
  StyledAppBarContainer,
  StyledBox,
  StyledGrid,
  StyledIconButton,
  StyledImg,
  StyledSubTabs,
  StyledTabs,
  StyledToolbar
} from "./AppBar.styled"
import { useTranslation } from "react-i18next"

const getTabs = (path, app) => {
  // app.normalPages
  // app.sysadmPages
  // häri kan vi hitta sidor som matchar vår nuvarande route längre upp i trädet på toplevelnivå
  // och hitta första nivån av undersidor

  let tabs = []
  let match = null

  const normalMatch = app.normalPages.filter((item) => path.startsWith(item.route.matchPath)) // sök bland normala sidor
  if (normalMatch.length > 0) {
    match = normalMatch[0] // första bästa
  }

  if (match === null) {
    const sysadmMatch = app.sysadmPages.filter((item) => path.startsWith(item.route.matchPath)) // sök bland sysadmin sidor
    if (sysadmMatch.length > 0) {
      match = sysadmMatch[0] // första bästa
    }
  }

  if (match !== null && match.tabs !== null) {
    tabs = match.tabs
  }

  return tabs
}

const getSubTabs = (path, currentTabs, subTabs) => {
  let tabs = []
  let match = null
  const subMatch = currentTabs.filter((item) => path.startsWith(item.path))

  if (subMatch.length > 0) {
    match = subMatch[0]
  }

  if (match !== null && match.subTabs !== null) {
    tabs = match.subTabs
  }
  return tabs
}

const getPreviousPage = (path, subTabs, t) => {
  let tabs = null
  let match = null
  if (subTabs.length > 0) {
    subTabs.map((subTab) => {
      if (subTab && subTab.subTabs !== null) {
        const subMatch = subTab.subTabs.find((item) => path === item.path)

        if (subMatch) {
          match = { title: t("global.buttons.back", "Back"), path: subTab.path }
        }
      }
    })
  }
  if (match !== null) {
    tabs = { title: t("global.buttons.back", "Back"), path: match.path }
  }

  return tabs
}

const MuAppBar = (props) => {
  // const { openDrawer, handleDrawerChange } = props

  const theme = useTheme()
  const appContext = React.useContext(AppContext)
  const location = useLocation()
  const matches = useMediaQuery(theme.breakpoints.up("sm"))
  const [tabs1, setTabs1] = React.useState([])
  const [subTabs, setSubTabs] = React.useState([])
  const [selectedPath, setPath] = useState()
  const [selectedSubPath, setSubPath] = useState()
  const [previousPage, setPreviousPage] = useState()

  const smUpHiddenBreakpoint = useMediaQuery((theme) => theme.breakpoints.up("sm"))
  const smDownHiddenBreakpoint = useMediaQuery((theme) => theme.breakpoints.down("sm"))
  const mdDownHiddenBreakpoint = useMediaQuery((theme) => theme.breakpoints.down("md"))
  const lgUpHiddenBreakpoint = useMediaQuery((theme) => theme.breakpoints.up("lg"))
  const { t } = useTranslation()

  useEffect(() => {
    if (appContext && appContext.appUser) {
      let tabs = getTabs(location.pathname, appContext.appUser.app)
      setTabs1(tabs)
      let currentSubTabs = getSubTabs(location.pathname, tabs, subTabs)
      setSubTabs(currentSubTabs)
      let currentPreviousPage = getPreviousPage(location.pathname, currentSubTabs, t)
      setPreviousPage(currentPreviousPage)
    }
  }, [appContext, location.pathname])

  useEffect(() => {
    if (!selectedPath) {
      setPath(location.pathname)
    }
  }, [selectedPath, location.pathname])

  useEffect(() => {
    if (!selectedSubPath) {
      setSubPath(location.pathname)
    }
  }, [selectedSubPath, location.pathname])

  const handleChange = (_event, newValue) => {
    setPath(newValue)
  }

  const handleChangeSubPath = (_event, newValue) => {
    setSubPath(newValue)
  }

  return (
    <StyledAppBar position="fixed">
      {smUpHiddenBreakpoint ? null : (
        <StyledAppBarContainer>
          <Box>
            <StyledIconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => appContext.toggleMainNav()}
              edge="start"
              size="large">
              <MenuIcon />
            </StyledIconButton>
          </Box>

          <Link style={{ opacity: "1" }} to={allRoutes.Dashboard()}>
            <StyledImg src={"assets/route-large.svg"} alt={"logo"} />
          </Link>

          <Box display="flex" alignItems="center">
            {appContext.isAuth && (
              <>
                <LanguageButton showLangName={true} />
                <LoginLogout />
              </>
            )}
          </Box>
        </StyledAppBarContainer>
      )}

      {smDownHiddenBreakpoint && tabs1.length === 0 ? null : (
        <StyledToolbar openDrawer={appContext.isMainNavOpen}>
          <StyledAppBarContainer flexend={tabs1 === null || tabs1.length <= 0}>
            {selectedPath != null && tabs1.length > 0 && (
              <StyledTabs
                onChange={handleChange}
                value={selectedPath}
                indicatorColor="primary"
                variant="scrollable"
                scrollButtons={matches && "auto"}>
                {tabs1.map((item, index) => {
                  return (
                    <Tab
                      key={item.title}
                      component={NavLink}
                      to={item.path}
                      label={
                        item.translationKey
                          ? t(`app.tabs.titles.${item.translationKey}`, item?.fallbackTitle)
                          : item.title
                      }
                      value={item.path}
                      isActive={(match, location) => {
                        if (!match) {
                          return false
                        }
                        setPath(match.url)
                      }}
                    />
                  )
                })}
              </StyledTabs>
            )}
            <Box
              display="flex"
              justifyContent={tabs1.length > 0 ? "space-between" : "flex-end"}
              alignItems="center">
              {mdDownHiddenBreakpoint ? null : (
                <Box display="flex" alignItems="center">
                  {appContext.isAuth && (
                    <>
                      <CrisisButton />
                      <LanguageButton showLangName={true} />
                      <CompanySelect />
                      <LoginLogout />
                    </>
                  )}
                </Box>
              )}
              <StyledBox alignItems="center">
                {appContext.isAuth && <LanguageButton />}
                <LoginLogout />
                <CompanySelect />
              </StyledBox>
            </Box>
            {previousPage && (
              <StyledGrid container direction="row" justifyContent="space-between" alignItems="center">
                <NavLink to={previousPage.path} label={previousPage.title} value={previousPage.path}>
                  <FontAwesomeIcon icon={faChevronLeft} size="xs" /> {previousPage.title}
                </NavLink>
              </StyledGrid>
            )}
          </StyledAppBarContainer>
        </StyledToolbar>
      )}
      {subTabs && subTabs.length > 0 && !previousPage && (
        <StyledToolbar openDrawer={appContext.isMainNavOpen}>
          <StyledSubTabs
            indicatorColor="primary"
            value={selectedSubPath}
            onChange={handleChangeSubPath}
            variant={"scrollable"}>
            {subTabs.map((item, index) => {
              return (
                <Tab
                  key={item.title}
                  component={NavLink}
                  to={item.path}
                  label={
                    item.translationKey
                      ? t(`app.tabs.titles.${item.translationKey}`, item?.fallbackTitle)
                      : item.title
                  }
                  value={item.path}
                  isActive={(match, location) => {
                    if (!match) {
                      return false
                    }
                    setSubPath(match.url)
                  }}
                />
              )
            })}
          </StyledSubTabs>
        </StyledToolbar>
      )}
      <ApiLoading />
    </StyledAppBar>
  )
}

export default MuAppBar
